{
  "name": "ivm-admin",
  "version": "2.8.69",
  "description": "ivm-admin",
  "private": true,
  "engines": {
    "node": "24",
    "npm": "11"
  },
  "scripts": {
    "set-env": "ts-node set-env.ts",
    "start": "node backend/dist/index.js",
    "test": "cd backend && npm run test",
    "batch": "cd backend && npm run batch",
    "backend:watch": "cd backend && npm run dev:watch",
    "build": "cd backend && tsc && cd .. && ng build --configuration production",
    "sdk": "cd backend && npm run sdk",
    "sdk:watch": "cd backend && npm run sdk:watch ",
    "angular:watch": "ng build --watch",
    "angular:serve": "ng serve --proxy-config proxy.config.json",
    "dev:watch": "concurrently --names \"Angular,Backend,SDK\" -c \"bgGreen.bold,bgBlue.bold,bgMagenta.bold\" \"npm run angular:watch\" \"npm run backend:watch\" \"npm run sdk:watch\"",
    "postinstall": "cd backend && npm i",
    "release": "generate-release"
  },
  "config": {
    "generateRelease": {
      "files_to_version": [
        "azure-pipelines.yml",
        "backend/package.json",
        "backend/package-lock.json",
        "package-lock.json"
      ]
    }
  },
  "dependencies": {
    "@angular/animations": "^21.2.9",
    "@angular/common": "^21.2.9",
    "@angular/core": "^21.2.9",
    "@angular/forms": "^21.2.23",
    "@angular/localize": "^21.2.23",
    "@angular/platform-browser": "^21.2.9",
    "@angular/platform-browser-dynamic": "^21.2.23",
    "@angular/router": "^21.2.23",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@popperjs/core": "2.11.8",
    "@types/chart.js": "^2.9.41",
    "angular-file": "^4.0.2",
    "bootstrap": "5.3.8",
    "chart.js": "^3.9.1",
    "chartjs-plugin-annotation": "^1.4.0",
    "merge-images": "^2.0.0",
    "moment": "^2.30.1",
    "ngx-image-cropper": "^9.1.7",
    "ngx-quill": "^29.2.0",
    "ngx-toastr": "^20.0.5",
    "quill": "2.0.2",
    "rxjs": "^7.8.2",
    "sanitize-html": "^2.17.7",
    "sortablejs": "^1.15.7",
    "stacktrace-gps": "^3.1.2",
    "stacktrace-js": "^2.0.2",
    "ts-json-schema-generator": "^2.9.0",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.4.0",
    "@angular-eslint/eslint-plugin": "^21.0.0",
    "@angular-eslint/eslint-plugin-template": "^21.0.0",
    "@angular-eslint/schematics": "^21.4.0",
    "@angular-eslint/template-parser": "^21.0.0",
    "@angular/build": "^21.2.24",
    "@angular/cli": "^21.2.24",
    "@angular/compiler": "^21.2.9",
    "@angular/compiler-cli": "^21.2.9",
    "@openapitools/openapi-generator-cli": "^2.41.0",
    "@types/lodash": "^4.17.25",
    "@types/node": "^18.19.130",
    "@types/sanitize-html": "^2.16.1",
    "@types/sortablejs": "^1.15.9",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "app-root-path": "^3.1.0",
    "codelyzer": "^6.0.2",
    "concurrently": "^5.3.0",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^9.1.2",
    "eslint-plugin-imengine": "file:eslint",
    "eslint-plugin-prettier": "^5.5.6",
    "generate-release": "^1.1.1",
    "nodemon": "^2.0.22",
    "prettier": "^3.9.6",
    "ts-node": "~5.0.1",
    "tslint": "~6.1.0",
    "typescript": "^5.9.3"
  },
  "overrides": {
    "path-to-regexp": "8.4.0"
  }
}
